import { DONATION_ROUTES } from '@/constants';

/** 데스크톱 헤더를 숨길 페이지 pathname 목록 */
export const HIDE_DESKTOP_HEADER_PATHNAMES: string[] = [
  DONATION_ROUTES.KB_CHECK_CARD.pathname,
];
